export default __webpack_public_path__ + "static/media/ijm_logo.e16efd2b.png";